import { offerSelector } from './offer';
import { IState } from '../../../store';

export const selectOfferSpecialties = (state: IState) => {
  const offer = offerSelector(state);

  return offer.specialty?.specialties ?? null;
};
